export default __webpack_public_path__ + "static/banner-background-pattern-a6295aee47790c6d6936f6ee214fc044.png";